import { useTranslation } from 'react-i18next';

import { ApiError } from '../../../../../Shared/interfaces/ApiError';
import { CustomCard } from '../../../../../UiComponentsLibrary/CustomCard';
import { ActionIconConfig } from '../../config/actionButtonConfig';
import { ButtonConfig } from '../../config/buttonConfig';
import { QueueSheetManagementRows } from '../../interface/QueueSheetInterface';
import { DownloadBookingFilters } from '../../utils/downloadFilters';
import BookingActionButtons from '../BookingActionButtons/BookingActionButtons';
import BookingTable from '../BookingTable/BookingTable';

interface BookingsSectionProps {
  bookingData: QueueSheetManagementRows[];
  isLoading: boolean;
  buttonConfig: ButtonConfig[];
  actionButtonConfig: ActionIconConfig[];
  handleExportBooking: (filters?: DownloadBookingFilters) => void;
  isDownloadDisabled: boolean;
  bookingError?: ApiError;
  brands: string[];
  slotPackages: string[];
  artEventId?: string;
  isCancelledView: boolean;
}

const BookingsSection = ({
  bookingData,
  isLoading,
  buttonConfig,
  actionButtonConfig,
  handleExportBooking,
  isDownloadDisabled,
  bookingError,
  brands,
  slotPackages,
  artEventId,
  isCancelledView,
}: BookingsSectionProps) => {
  const { t } = useTranslation();

  return (
    <CustomCard
      id="active-booking-card"
      title={isCancelledView ? t('cancelled-booking-title') : t('active-booking-title')}
      actions={
        <BookingActionButtons
          buttonConfig={buttonConfig}
        />
      }
    >
      <BookingTable
        bookingError={bookingError}
        bookingData={bookingData}
        isLoading={isLoading}
        actionButtonConfig={actionButtonConfig}
        brands={brands}
        slotPackages={slotPackages}
        artEventId={artEventId}
        handleExportBooking={handleExportBooking}
        isDownloadDisabled={isDownloadDisabled}
        isCancelledView={isCancelledView}
      />
    </CustomCard>
  );
};

export default BookingsSection;
